import {I18n} from "./I18n";
import {URLProcessor} from "./URL";
import {Basket} from "./Basket";
import {App3D} from '../app3D/App3D';
import {Utils} from '../app3D/Utils';


export class App {
	public i18n:I18n;
	public url:URLProcessor;
	public basket: Basket;
	// constructor(){
	// 	this.attachEvents();
	// }

	constructor(
			protected app3D: App3D,
			options:{}={}){
		this.i18n = new I18n(app3D.config);
		this.url = new URLProcessor(app3D.$);
		let opts = new Utils.Options(options);
		if (opts.get('pulseButtons', false))
			app3D.gui.pulseButtons();

		this.basket = new Basket('table#basket');
		app3D.$('#order').find('button.add').click(() => this.basket.add(app3D.getCurrentConfig(), 1));
	}

	public switchLang(src) {
		this.i18n.setLang(src.value);
		this.url.setGET(new Map<string, string>(
				[['l', src.value]]));
	}
}



// WEBPACK FOOTER //
// ./src/script/app/App.ts